module.exports = __webpack_public_path__ + "img/no-qbo-vendor.6bf20d7c.svg";